import { combineReducers } from 'redux';

import settingsReducer from './settings/SettingsReducer';
import guidesReducer from './guides/reducer';
import themesReducer from './themes/reducer';
import segmentsReducer from './segments/reducer';
import recordingReducer from './guides/recording/RecordingReducer';

const ApplicationDetailReducer = combineReducers({
    settings: settingsReducer,
    guides: guidesReducer,
    themes: themesReducer,
    segments: segmentsReducer,
    recording: recordingReducer,
});

export default ApplicationDetailReducer;
